import React, { Component } from 'react';

class StatsPage extends Component {

    constructor(props) {
        super(props);
        const userData = this.getUserData();
        this.state = { 
            stats: userData,
            newStats: {},
            usedPoints: 0,
        };
        
        this.setNewStat = this.setNewStat.bind(this);
    }

    getUserData() {
        return {
            username: 'something',
            availablePoints: 123,
        };
    }

    setNewStat(stat) {
        this.setState({
            newStats: Object.assign(this.state.newStats, stat)
        }, this.recalculatePoints)
    }

    recalculatePoints() {
        let usedPoints = 0;
        for (const [value] of Object.entries(this.state.newStats)) {
            usedPoints += value.cost;
        }

        this.setState({
            usedPoints
        });
    }

    saveConfig() {
        // Make post request for the proposed changes...
    }

    render() {
        return (
            <div className="mb-page">
                <h2>Stats Page</h2>
                <h1>UNDER CONSTRUCTION</h1>
            </div>
        )
    }
}

export default StatsPage;


// WEBPACK FOOTER //
// ./src/StatsPage.js